/* Sequential Racing: "My car" saved vehicle (Claude, Oct 2026). See snippets/sr-garage.liquid */
(function () {
  var dataEl = document.getElementById('sr-garage-data');
  if (!dataEl || window.SRGarage) return;
  var CFG;
  try { CFG = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var CARS = CFG.cars.filter(function (c) { return c.n > 0; });
  var KEY = 'sr-garage', HOME_KEY = 'sr-vehicle', TTL = 6 * 36e5;

  var CAR_SVG = '<svg viewBox="0 0 32 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.2 12.4V10c0-.8.5-1.4 1.2-1.6L8 7.2l3.5-3.1c.6-.5 1.3-.8 2.1-.8h5.7c.8 0 1.5.3 2.1.9l3.1 3 3.7.8c1 .2 1.7 1.1 1.7 2.1v2.3M10.9 12.4h10.2M2.2 12.4h4M25.9 12.4h3.9"/><circle cx="8.5" cy="12.4" r="2.3"/><circle cx="23.5" cy="12.4" r="2.3"/></svg>';
  var TICK = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.2 8.4l3 3 6.6-7"/></svg>';
  var WARN = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="8" cy="8" r="6.3"/><path d="M8 4.8v3.8M8 11.1v.1"/></svg>';
  var X = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3.5 3.5l9 9M12.5 3.5l-9 9"/></svg>';

  function ls(k, v) {
    try {
      if (v === undefined) return localStorage.getItem(k);
      if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function current() { var k = ls(KEY); return CARS.find(function (c) { return c.k === k; }) || null; }
  function label(c) { return c.label; }
  /* BMW: one collection per generation, so the product title decides the model.
     A title naming specific chassis (e.g. "G87 M2") only fits those; a title with none, or "F8X"/"G8X", fits the whole generation. */
  var CODE_RE = /\b([FG]8[0-9X])\b/gi;
  function titleCodes(t) { var m = String(t || '').toUpperCase().match(CODE_RE) || []; return m.filter(function (x, i) { return m.indexOf(x) === i; }); }
  function familyOf(c) { return CARS.filter(function (x) { return x.c === c.c; }); }
  function fitsTitle(c, title) {
    if (!c.codes || !c.codes.length) return true;
    var fam = [], codes = titleCodes(title);
    familyOf(c).forEach(function (x) { fam = fam.concat(x.codes); });
    if (codes.some(function (x) { return /X$/.test(x) && x[0] === c.codes[0][0]; })) return true;
    var named = codes.filter(function (x) { return fam.indexOf(x) > -1; });
    if (!named.length) return true;
    return named.some(function (x) { return c.codes.indexOf(x) > -1; });
  }
  function namedCars(c, title) {
    var codes = titleCodes(title);
    return familyOf(c).filter(function (x) { return x.codes.some(function (y) { return codes.indexOf(y) > -1; }); });
  }
  function genName(c) { return 'BMW ' + c.codes[0][0] + '8X'; }

  /* ---------- header button ---------- */
  var btn = null;
  function mountButton() {
    var icons = document.querySelector('.header__icons');
    if (!icons || icons.querySelector('.srgx-btn')) return;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'srgx-btn';
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.innerHTML = CAR_SVG + '<span class="srgx-btn__t"></span>';
    btn.addEventListener('click', function () { open(btn); });
    var cart = icons.querySelector('.header__icon--cart');
    icons.insertBefore(btn, cart || null);
    paintButton();
  }
  function paintButton() {
    if (!btn) return;
    var c = current();
    btn.classList.toggle('is-set', !!c);
    btn.querySelector('.srgx-btn__t').textContent = c ? label(c) : 'Add your car';
    btn.setAttribute('aria-label', c ? 'Your car: ' + c.label + '. Change car' : 'Add your car');
  }

  /* ---------- picker ---------- */
  var dlg = null, opener = null;
  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'srgx';
    dlg.setAttribute('aria-labelledby', 'srgx-h');
    var makes = [], html = '';
    CARS.forEach(function (c) { if (makes.indexOf(c.make) < 0) makes.push(c.make); });
    makes.forEach(function (m) {
      html += '<p class="srgx__make">' + esc(m) + '</p><div class="srgx__group">';
      CARS.filter(function (c) { return c.make === m; }).forEach(function (c) {
        html += '<button type="button" class="srgx__car" data-k="' + esc(c.k) + '" aria-pressed="false"><span><span class="srgx__n">' + esc(c.name) + '</span><span class="srgx__s">' + esc(c.sub) + '</span></span><span class="srgx__ct">' + (c.codes && c.codes.length ? '' : c.n + ' parts') + '</span><span class="srgx__tick">' + TICK + '</span></button>';
      });
      html += '</div>';
    });
    dlg.innerHTML =
      '<div class="srgx__in">' +
      '<button type="button" class="srgx__x" aria-label="Close">' + X + '</button>' +
      '<h2 class="srgx__h" id="srgx-h">What do you drive?</h2>' +
      '<p class="srgx__p">Pick your car and we\'ll show which parts are listed for it as you browse. It\'s saved on this device only.</p>' +
      html +
      '<div class="srgx__foot" hidden><a class="srgx__go" href="#"></a><button type="button" class="srgx__clear">Remove my car</button></div>' +
      '</div>';
    document.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) return close();
      var car = e.target.closest('.srgx__car');
      if (car) { set(car.getAttribute('data-k')); close(); return; }
      if (e.target.closest('.srgx__x')) return close();
      if (e.target.closest('.srgx__clear')) { set(null); paintDialog(); }
    });
    dlg.addEventListener('close', function () {
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (opener && opener.isConnected) opener.focus();
    });
  }
  function paintDialog() {
    var c = current();
    dlg.querySelectorAll('.srgx__car').forEach(function (b) { b.setAttribute('aria-pressed', c && b.getAttribute('data-k') === c.k ? 'true' : 'false'); });
    var foot = dlg.querySelector('.srgx__foot');
    foot.hidden = !c;
    if (c) {
      var go = dlg.querySelector('.srgx__go');
      go.href = c.url;
      go.textContent = 'Shop ' + label(c) + ' parts';
    }
  }
  function place(from) {
    var desk = window.matchMedia('(min-width: 750px)').matches;
    dlg.classList.toggle('srgx--sheet', !desk);
    if (desk && from && from.getBoundingClientRect) {
      var r = from.getBoundingClientRect(), w = Math.min(420, window.innerWidth - 32);
      var left = Math.max(16, Math.min(r.right - w, window.innerWidth - w - 16));
      var top = r.bottom + 8;
      if (top > window.innerHeight * 0.5) top = 16;
      dlg.style.left = left + 'px';
      dlg.style.top = top + 'px';
      dlg.style.maxHeight = Math.max(320, window.innerHeight - top - 16) + 'px';
    } else {
      dlg.style.left = dlg.style.top = dlg.style.maxHeight = '';
    }
  }
  function open(from) {
    if (!dlg) build();
    opener = from || document.activeElement;
    paintDialog();
    place(from);
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    var sel = dlg.querySelector('.srgx__car[aria-pressed="true"]') || dlg.querySelector('.srgx__car');
    if (sel) sel.focus();
  }
  function close() { if (dlg && dlg.open) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); } }

  function set(k) {
    if (k) { ls(KEY, k); var hc = CARS.find(function (c) { return c.k === k; }); if (hc && hc.home) ls(HOME_KEY, hc.home); } else { ls(KEY, null); }
    paintButton();
    paintFit();
    tagCards(true);
    document.dispatchEvent(new CustomEvent('sr:garage', { detail: { car: current() } }));
  }

  /* ---------- product page fit line ---------- */
  function paintFit() {
    document.querySelectorAll('[data-srgx-fit]').forEach(function (el) {
      var cols = (el.getAttribute('data-c') || '').split(',').filter(Boolean);
      var title = el.getAttribute('data-t') || '';
      var carCols = CARS.map(function (c) { return c.c; });
      var mine = cols.filter(function (h, i) { return carCols.indexOf(h) > -1 && cols.indexOf(h) === i; });
      var famHit = cols.indexOf(CFG.fam) > -1;
      var c = current(), html = '', mod = '', change = '<button type="button" class="srgx-fit__a" data-srgx-open>Change car</button>';
      var ask = '<a href="' + esc(CFG.contact) + '">Ask us</a>';
      if (!mine.length && !famHit) { el.hidden = true; return; }
      if (!c) {
        mod = 'ask';
        html = '<span class="srgx-fit__i">' + CAR_SVG + '</span><span>Want to check this suits your car?</span><button type="button" class="srgx-fit__a" data-srgx-open>Add your car</button>';
      } else if (cols.indexOf(c.c) > -1 && fitsTitle(c, title)) {
        mod = 'yes';
        html = '<span class="srgx-fit__i">' + TICK + '</span><span>Fits your ' + esc(c.label) + '</span>' + change;
      } else if (cols.indexOf(c.c) > -1) {
        mod = 'no';
        var other = namedCars(c, title).map(function (x) { return x.label; });
        html = '<span class="srgx-fit__i">' + WARN + '</span><span>Not for your ' + esc(c.label) + (other.length ? '. This one is made for the ' + esc(other.join(' and ')) : '') + '. ' + ask + ' if you\'re not sure.</span>' + change;
      } else if (c.codes && c.codes.length && famHit && !mine.length) {
        mod = 'maybe';
        html = '<span class="srgx-fit__i">' + WARN + '</span><span>Listed for BMW M models. ' + ask + ' to confirm it suits your ' + esc(c.label) + '.</span>' + change;
      } else {
        mod = 'no';
        var names = [];
        mine.forEach(function (h) {
          var x = CARS.find(function (y) { return y.c === h; });
          var n = x.codes && x.codes.length ? genName(x) : x.label;
          if (names.indexOf(n) < 0) names.push(n);
        });
        html = '<span class="srgx-fit__i">' + WARN + '</span><span>Not listed for your ' + esc(c.label) + (names.length ? ' (it\'s listed for the ' + esc(names.join(', ')) + ')' : '') + '. ' + ask + ' before ordering.</span>' + change;
      }
      el.className = 'srgx-fit srgx-fit--' + mod;
      el.innerHTML = html;
      el.hidden = false;
    });
  }

  /* ---------- tags on product cards ---------- */
  var handles = null, loadingFor = null;
  function getHandles(c) {
    var cacheKey = 'srgx-h2-' + c.k, cached = null;
    try { cached = JSON.parse(ls(cacheKey) || 'null'); } catch (e) {}
    if (cached && Date.now() - cached.t < TTL && cached.n === c.n) return Promise.resolve(cached.h);
    var base = c.url + '?view=sr-fit';
    function page(p) {
      return fetch(base + '&page=' + p, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t.trim()); });
    }
    return page(1).then(function (first) {
      var more = [];
      for (var p = 2; p <= Math.min(first.p || 1, 8); p++) more.push(page(p));
      return Promise.all(more).then(function (rest) {
        var all = [first].concat(rest), h = [];
        all.forEach(function (r) { r.h.forEach(function (x, i) { if (fitsTitle(c, (r.t || [])[i])) h.push(x); }); });
        ls(cacheKey, JSON.stringify({ t: Date.now(), n: c.n, h: h }));
        return h;
      });
    });
  }
  function tagCards(reset) {
    var c = current();
    if (reset) {
      document.querySelectorAll('.srgx-tag').forEach(function (t) { t.remove(); });
      handles = null;
    }
    if (!c || (CFG.here === c.c && !(c.codes && c.codes.length))) return;
    if (!document.querySelector('.product-card[data-product-handle]')) return;
    if (!handles) {
      if (loadingFor === c.k) return;
      loadingFor = c.k;
      getHandles(c).then(function (h) {
        loadingFor = null;
        if (!current() || current().k !== c.k) return;
        handles = new Set(h);
        tagCards(false);
      }).catch(function () { loadingFor = null; });
      return;
    }
    document.querySelectorAll('.product-card[data-product-handle]').forEach(function (card) {
      if (!handles.has(card.getAttribute('data-product-handle'))) return;
      var host = card.querySelector('.card__inner') || card;
      if (host.querySelector('.srgx-tag')) return;
      var t = document.createElement('span');
      t.className = 'srgx-tag';
      t.innerHTML = TICK + 'Fits your ' + esc(c.tag);
      host.appendChild(t);
    });
  }

  /* ---------- wiring ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-srgx-open]');
    if (o) { e.preventDefault(); open(o); }
  });
  var moTimer = null;
  function init() {
    mountButton();
    paintFit();
    tagCards(false);
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        clearTimeout(moTimer);
        moTimer = setTimeout(function () { if (!btn || !btn.isConnected) { btn = null; mountButton(); } tagCards(false); }, 250);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  window.SRGarage = { open: open, set: set, current: current };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
